export function hasLatexMathBlocks(text: string) {
  return (
    /([^$\\]|^)\$(?!\d)(.*)[^$\\]\$([^\d]|$)/.test(text) || // Inline math with non-digit boundaries, e.g.: $a + b$
    /([^$\\]|^)\$([\d]+|[\d]+\.[\d]*|[\d]*\.[\d]+)\$([^$]|$)/.test(text) || // Inline math with a number, e.g.: $3$, $3.14$, $.5$
    /([^$\\]|^)\$\$(.+)([^$\\]|^)\$\$/.test(text) ||
    /\\\((.+)\\\)/.test(text) ||
    /\\\[.+\\\]/.test(text) ||
    /\\begin{equation}.+\\end{equation}/.test(text) ||
    /\\begin{align}.+\\end{align}/.test(text)
  );
}
